module.exports = __webpack_public_path__ + "img/cultura1.21652081.png";